<div
  class="flex items-center justify-between pb-4 mb-4 border-b border-dashed border-border"
  style="min-height: 60px"
>
  <div class="flex items-start gap-4 flex-1">
    @if (icon || logoUrl) {
      <div
        class="flex items-center justify-center shrink-0 w-11 h-11 rounded-xl transition-all duration-200"
        [ngClass]="
          icon ? 'bg-primary' : 'bg-surface border border-border shadow-sm'
        "
      >
        @if (icon) {
          <i
            [ngClass]="icon"
            class="text-[18px] text-on-primary inline-flex items-center justify-center"
          ></i>
        }
        @if (logoUrl) {
          <img
            [src]="logoUrl"
            alt="bank logo"
            class="w-[28px] h-[28px] object-contain"
          />
        }
      </div>
    }

    <div class="flex flex-col justify-center min-h-[40px]">
      @if (title) {
        <h2 class="text-lg font-semibold text-text-primary leading-tight m-0">
          {{ title }}
        </h2>
      }
      @if (description) {
        <p class="text-sm text-text-muted mt-0.5 mb-0">{{ description }}</p>
      }
    </div>
  </div>

  <div class="flex items-center gap-2">
    <ng-content select="[card-actions]"></ng-content>
  </div>
</div>
